import { render, staticRenderFns } from "./RecommendBestItem.vue?vue&type=template&id=0d2eb404&"
import script from "./RecommendBestItem.vue?vue&type=script&lang=js&"
export * from "./RecommendBestItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/hanmail/src/cafe-top/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0d2eb404', component.options)
    } else {
      api.reload('0d2eb404', component.options)
    }
    module.hot.accept("./RecommendBestItem.vue?vue&type=template&id=0d2eb404&", function () {
      api.rerender('0d2eb404', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/home/RecommendBestItem.vue"
export default component.exports